import DailyGoalCommunication from '~/pages/communication/dailyGoal/libs/components/DailyGoalCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const DailyGoalCommunicationPage = (props: TPageProps) => (
  <DailyGoalCommunication {...props} />
)

export default DailyGoalCommunicationPage
